module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_8011.b8a7a5da.png";